<template>
  <div v-if="addons.length" class="d-flex justify-content-start flex-wrap">
    <div
      v-for="(addonType, index) in sortedAddons"
      :key="`addon-badge-${addonType}-${index}`"
      :class="getAddonClass(addonType, index)"
    >
      <span v-if="isVivaincontri && addonType === 'supertop'">
        {{ i18n.superhot }}
      </span>
      <span v-else>{{ formatAddonTitle(addonType) }}</span>
    </div>
  </div>
</template>


<script>
// import Translations from "./insert-me-to-translate.vue";
import { formatAddonTitle } from './post-promote-constants';

const ADDONS_ORDER = {
    "supertop": 0,
    "highlight": 1,
    "new_label": 2
};

export default {
  props: {
    addons: {
      type: Array,
      required: true,
    },
    isVivaincontri: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      i18n: {
        superhot: gettext("SuperHot"),
      }
    }
  },
  computed: {
    sortedAddons() {
      return this.addons.sort((a, b) => ADDONS_ORDER[a] - ADDONS_ORDER[b]);
    },
  },
  methods: {
    formatAddonTitle(type) {
        return formatAddonTitle(type);
    },
    getAddonClass(type, index) {
      return [
        'input-addons__title',
        type === 'supertop' && !this.isVivaincontri ? 'icon-supertop' : '',
        index > 0 ? 'plus ' : '',
      ];
    },
  },
}
</script>

<style>
.input-addons__title {
  width: auto;
  min-height: 25px;
  font-size: 11px;
  border-radius: 3px;
  color: rgba(48, 122, 187, 1);
  background: rgba(48, 122, 187, 0.1);
  position: relative;
  text-align: center;
  padding: 0.25rem;
  margin-right: 12px;
  font-weight: 700;
  margin-bottom: 5px;
  display: flex;
  justify-self: center;
  align-items: center;
}
body.vivaincontri .input-addons__title {
  border: var(--border-width) solid var(--color-secondary);
  background: var(--color-secondary-light);
  color: var(--color-secondary);
}

.input-addons__title.icon-supertop {
  font-weight: normal;
}
.input-addons__title:after {
  font-weight: 700;
}
.input-addons__title:before {
  vertical-align: sub;
  position: relative;
  top: 1px;
}
.plus {
  font-weight: 700;
}
.plus:after {
  content: "+";
  position: absolute;
  left: -12px;
  font-size: 13px;
  top: 0px;
  font-weight: 700;
  line-height: 25px;
  height: 25px;
  border: 1px solid transparent;
}
@media (max-width: 469px) {
  .input-addons__title {
    display: inline-table;
  }
}
</style>